var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0Cold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 112,
    viewBox: "0 0 168 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9324 80.5088L17.0137 82.6136L17.0137 82.6136L11.9324 80.5088ZM32.7153 59.1146C34.8631 56.9667 34.8631 53.4843 32.7153 51.3364C30.5674 49.1885 27.085 49.1885 24.9371 51.3364L32.7153 59.1146ZM11.5001 110.333C11.5001 100.82 13.3736 91.4016 17.0137 82.6136L6.85105 78.4041C2.65814 88.5266 0.500089 99.3759 0.500088 110.333L11.5001 110.333ZM17.0137 82.6136C20.6538 73.8256 25.9892 65.8406 32.7153 59.1146L24.9371 51.3364C17.1896 59.0839 11.044 68.2815 6.85105 78.4041L17.0137 82.6136Z",
    fill: "#99D1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.934 80.5088L150.852 82.6136L150.852 82.6136L155.934 80.5088ZM135.151 59.1146C133.003 56.9667 133.003 53.4843 135.151 51.3364C137.299 49.1885 140.781 49.1885 142.929 51.3364L135.151 59.1146ZM156.366 110.333C156.366 100.82 154.493 91.4016 150.852 82.6136L161.015 78.4041C165.208 88.5266 167.366 99.3759 167.366 110.333L156.366 110.333ZM150.852 82.6136C147.212 73.8256 141.877 65.8406 135.151 59.1146L142.929 51.3364C150.677 59.0839 156.822 68.2815 161.015 78.4041L150.852 82.6136Z",
    fill: "#008BF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1797 54.8742C36.4626 47.6839 45.0904 41.9984 54.5705 38.1424C64.0506 34.2864 74.1974 32.3355 84.4315 32.4009C94.6656 32.4663 104.787 34.5469 114.217 38.5238C123.647 42.5006 132.201 48.296 139.392 55.5788",
    stroke: "#4DAEF5",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5197 109.787L81.3848 64.2637C81.6328 61.9426 84.9788 61.8548 85.3483 64.1597L92.6459 109.683C92.8408 110.899 91.902 112 90.6712 112H78.5083C77.3197 112 76.3933 110.969 76.5197 109.787Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Cold);
export default __webpack_public_path__ + "static/media/0-cold.64cc9eab.svg";
export { ForwardRef as ReactComponent };